import { z } from 'zod';
import { VIEWER_TYPES } from '#server/models';

export const viewerRouteParamsSchema = z.object({
  areaSlug: z.string(),
  viewerType: z.enum(VIEWER_TYPES),
  subjectSlug: z.string()
});

export type ViewerRouteParams = z.infer<typeof viewerRouteParamsSchema>;

export const viewerSearchParamsSchema = z.object({
  selectedLabel: z.string().optional(),
  debug: z.string().optional(),
  raycast: z.string().optional()
});

export type ViewerSearchParams = z.infer<typeof viewerSearchParamsSchema>;
